module.exports = __webpack_public_path__ + "static/media/protecao.c6954eb0.png";